import { render, staticRenderFns } from "./ReportButton.vue?vue&type=template&id=27fb069a&scoped=true"
import script from "./ReportButton.vue?vue&type=script&lang=ts"
export * from "./ReportButton.vue?vue&type=script&lang=ts"
import style0 from "./ReportButton.vue?vue&type=style&index=0&id=27fb069a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb069a",
  null
  
)

export default component.exports